import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { ReviewsAdmin } from '../components/Admin/ReviewsAdmin';
import { CoursesAdmin } from '../components/Admin/CoursesAdmin';
import { TeachersAdmin } from '../components/Admin/TeachersAdmin';
import { ScheduleAdmin } from '../components/Admin/ScheduleAdmin';
import './Admin.css';

type AdminTab = 'reviews' | 'courses' | 'teachers' | 'schedule';

export const Admin: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [activeTab, setActiveTab] = useState<AdminTab>('reviews');

    // Простая проверка (в реальности лучше использовать токены)
    const handleLogin = (e: React.FormEvent) => {
        e.preventDefault();
        if (password === '123321') { // Замените на реальный пароль
            setIsAuthenticated(true);
            localStorage.setItem('admin_auth', 'true');
        } else {
            alert('Неверный пароль!');
        }
    };

    useEffect(() => {
        if (localStorage.getItem('admin_auth') === 'true') {
            setIsAuthenticated(true);
        }
    }, []);

    if (!isAuthenticated) {
        return (
            <div className="login-container">
                <form onSubmit={handleLogin} className="login-form">
                    <h2>Вход в админку</h2>
                    <input
                        type="password"
                        placeholder="Введите пароль"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <button type="submit">Войти</button>
                </form>
            </div>
        );
    }

    return (
        <div className="admin-container">
            <div className="admin-header">
                <h1>Панель администратора</h1>
                <Link to="/" className="back-link">← На сайт</Link>
            </div>

            <div className="admin-tabs">
                <button
                    className={`tab ${activeTab === 'reviews' ? 'active' : ''}`}
                    onClick={() => setActiveTab('reviews')}
                >
                    Отзывы
                </button>
                <button
                    className={`tab ${activeTab === 'courses' ? 'active' : ''}`}
                    onClick={() => setActiveTab('courses')}
                >
                    Курсы
                </button>
                <button
                    className={`tab ${activeTab === 'teachers' ? 'active' : ''}`}
                    onClick={() => setActiveTab('teachers')}
                >
                    Преподаватели
                </button>
                <button
                    className={`tab ${activeTab === 'schedule' ? 'active' : ''}`}
                    onClick={() => setActiveTab('schedule')}
                >
                    Расписание
                </button>
            </div>

            <div className="admin-content">
                {activeTab === 'reviews' && <ReviewsAdmin />}
                {activeTab === 'courses' && <CoursesAdmin />}
                {activeTab === 'teachers' && <TeachersAdmin />}
                {activeTab === 'schedule' && <ScheduleAdmin />}
            </div>
        </div>
    );
};